// extracted by mini-css-extract-plugin
export default {"fragments":"styles_fragments__hxgia","metro":"styles_metro__vhhvx"};